import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreCustomerCurrentWatchers, coreCustomersCurrentReducers } from './current';
import { coreCustomersByIdReducers, coreCustomersByIdWatchers } from './_id';

export const coreCustomersReducers = combineReducers({
	byId: coreCustomersByIdReducers,
	current: coreCustomersCurrentReducers
});

export const coreCustomersWatchers = combineAllWatchers([
	coreCustomersByIdWatchers,
	coreCustomerCurrentWatchers
]);
